import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Event, NavigationEnd } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-drawer',
  imports: [DrawerModule],
  template: `<p-drawer
    [(visible)]="visible"
    [position]="position"
    [styleClass]="styleClass"
  >
    @if (title) {
      <ng-template #header>
        <h1 class="tw-m-0 tw-text-lg tw-font-semibold tw-leading-snug">
          {{ title }}
        </h1>
      </ng-template>
    }
    <ng-content></ng-content>
  </p-drawer>`,
  styles: ``,
})
export class DrawerComponent extends BaseComponent {
  _visible = false;

  @Input()
  get visible(): boolean {
    return this._visible;
  }
  set visible(value: boolean) {
    this._visible = value;
    this.visibleChange.emit(value);
  }

  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Input()
  position = 'left';

  @Input()
  styleClass: string;

  @Input()
  title: string;

  constructor() {
    super();
    this.dispose.subs = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.visible = false;
      }
    });
  }
}
